import { Component, OnInit,Inject } from '@angular/core';
import { SseService } from 'src/app/services/SseService';
import { CookieService } from 'ngx-cookie-service';
import { MatDialogRef, MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-gestor-modelo-dialog',
  templateUrl: './gestor-modelo-dialog.component.html',
  styleUrl: './gestor-modelo-dialog.component.scss'
})
export class GestorModeloDialogComponent  implements OnInit{
  listModelo: any;
  licencia: string;
  public optimaseleccionada: any;
  public idModelo:number = 0; 
  public idCartera:number = 0;
  token: any;
  theme: any;
  constructor(private _sseservice: SseService,private _cookieService: CookieService,@Inject(MAT_DIALOG_DATA) public data: any, private toastr: ToastrService, public dialogRef: MatDialogRef<GestorModeloDialogComponent>){

  }
  ngOnInit(): void {
    this.theme = localStorage.getItem('theme') || 'light-theme';
    this.idModelo = this.data.idModelo;
    this.idCartera = this.data.idCartera;
    this.token = this.data.token;
    this.licencia = this._cookieService.get('auth_token');
    this.getListaCarteras();
 }
 abrirCartera(): void {

    this._sseservice.apiPostNew('suscripciones/registrarGestorModelo', {idcartera: this.optimaseleccionada.idcartera, idModelo: this.idModelo, idmercado: this.idCartera}, this.token).subscribe({
      next: (data:any)=>{
        console.log(data);
        if(data.status){
        this.toastr.success('La Cuenta ha sido vinculada', 'OK', { timeOut: 5000, positionClass: 'toast-top-center' });
        this.dialogRef.close(data.status);
      }else{
        this.toastr.error('Error.', 'Error', { timeOut: 5000, positionClass: 'toast-top-center' });
      }
      }
    });
 }
 getListaCarteras(){
  this._sseservice.apiPostNew('listarcarteras',null, this.licencia ).subscribe(response => {
    let data = response;
    data = data.filter((item: { subCarteras: string; }) => item.subCarteras === "");

    this.listModelo = data;
    console.log(this.listModelo);
  });
}
}
